import { getTranslations } from "../../app/i18n"
import { useLocale } from "../../app/locale-context"
import { cn } from "../../lib/utils"

interface Props {
	count: number
	className?: string
}

export function ChatUnreadBadge({ count, className }: Props) {
	const { locale } = useLocale()
	const t = getTranslations(locale).chat.unreadBadge
	if (count <= 0) return null
	const visible = count >= 100 ? t.cap : String(count)
	const ariaLabel = t.label.replace("{count}", String(count))
	return (
		<span
			role="status"
			aria-label={ariaLabel}
			className={cn(
				"min-w-[20px] h-[20px] px-1 rounded-full bg-primary text-primary-foreground text-[11px] font-bold flex items-center justify-center shadow-sm pointer-events-none",
				className,
			)}
		>
			{visible}
		</span>
	)
}
